
<template>
  <span v-if="datas && show" class="tagWrap">
    <span
      :class="['single-tag', datas.mktFrontType ? 'tag' + datas.mktFrontType : '', CookiesOne && CookiesOne == 'en-US' ? ' tagEn' : '', putName ? 'tag' + putName : '']"
      :style="getCss(datas)"
    >
      <span>{{ getText(datas) }}</span>
    </span>
  </span>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  name: 'SingleTag',
  props: {
    datas: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: false,
    },
    putName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      CookiesOne:Cookies.get('df_lang'),
    };
  },
  methods: {
    getCss(val) {
      if (!val) {
        return null;
      }
      const type = Number(val.mktFrontType);
      let cssJson = {};
      if (type) {
        switch(type){
          case 1001: // 特价
            cssJson = { color: '#F75E35', border: '0.75px solid #f65739' };
              break;
          case 1004: // 抢购
            cssJson = { color: '#F75E35', border: '0.75px solid #F75E35' };
              break;
          case 9001: // 新品
            cssJson = { color: '#60BF1D', border: '0.75px solid #60BF1D' };
              break;
          case 2001: // 满减
            cssJson = { color: '#f75e35', border: '0.75px solid #f75e35' };
              break;
          case 9003: // 限购
            cssJson = { minWidth: '48px', width: 'auto', lineHeight: '16px', padding: '0 1px', color: '#F75E35', border: 'none', background: 'linear-gradient(192deg, rgba(255, 175, 0, 0.1) 0%, rgba(244, 69, 69, 0.1) 100%)' }
            break;
          case 9004: // 起购
            cssJson = { minWidth: '48px', width: 'auto', lineHeight: '16px', padding: '0 1px', color: '#F75E35', border: 'none', background: 'linear-gradient(192deg, rgba(255, 175, 0, 0.1) 0%, rgba(244, 69, 69, 0.1) 100%)' }
            break;
          case 9005: // 频道名称
            cssJson = { minWidth: '24px', width: 'auto', padding: '0 4px', color: val.fontColor, border: 'none', background: val.backgroundColor };
            break;
          case 300001: // 抽奖
            cssJson = { color: '#F75E35', border: '0.75px solid #F75E35' };
            break;
        } 
      } else if (val.name) {
          cssJson = { color: '#F75E35', border: '0.75px solid #F75E35' };
      }
      return cssJson;
    },
    getText(val) {
      if (!val) {
        return null;
      }
      const type = Number(val.mktFrontType);
      let str = '';
      if (type) {
        switch(type){
          case 1001: // 特价
            str = this.TLang('特价', 'my');
              break;
          case 1004: // 抢购
            str = this.TLang('抢购', 'my');
              break;
          case 9001: // 新品
            str = this.TLang('新品', 'list');
              break;
          case 2001: // 满减
            str = this.TLang('满减', 'list');
              break;
          case 9003: // 限购
            str = val.mktText;
            break;
          case 9004: // 起购
            str = val.mktText;
            break;
          case 9005: // 频道名称
            str = val.mktText;
            break;
          case 300001: // 抽奖
            str = this.TLang('抽奖', 'list');
              break;
        } 
      } else if (val.name) {
          str = val.name;
      }
      return str;
    },
  },
};
</script>

<style lang="less" scoped>
.tagWrap {
  margin-top: 0 !important;
}
.single-tag {
  display: block;
  min-width: 32px;
  height: 16px;
  border-radius: 9px;
  line-height: 14.5px;
  box-sizing: border-box;
  text-align: center;
  font-size: 10px !important;
  margin-top: 0;
  padding: 0px 2px;
}
.tag9005{
  display: inline-block;
  width: auto;
  height: 16px;
  line-height: 16px;
  border-radius: 2px;
  font-size: 11px !important;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.tag1004.tagEn{
  width: 64px;
}
.tag1001.tagEn{
  width: 72px;
}
.tag2001.tagEn{
  width: 64px;
}
.tag9001.tagEn{
  width: 72px;
}
.tagPrizeGoods{
  display: inline-block;
  width: auto;
  height: 16px;
  line-height: 14px;
  border-radius: 2px;
  // margin-right: 2px;
}
</style>